<template>
  <div>
    <span class="experiment__line"></span>
    <div class="d-flex justify-content-between align-content-center experiment--padding mt-1">
      <div class="d-flex">
        <img src="" alt="">
        <div>
          <h4 class="text-left text--black"> {{student.email}}</h4>
          <p class="text--small"> {{student.first_name}} {{student.last_name}} </p>
        </div>
      </div>
      <div>
        <router-link :to="{ path: `/students_result_list/${student.id}` }" tag="button"
          class="btn btn-primary btn-sm mt-0" v-scroll-to="'#scrollToOnLoad'">
          Experiments
        </router-link>
        <!-- <b-btn variant="primary" size="sm" class="mt-0">Experiments</b-btn> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['student'],
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
.experiment {
  &__line {
    border-bottom: 3px solid $color--white-3;
    display: block;
  }
  &--padding {
    padding: 20px 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Game/ListOfStudents/ListOfStudents.vue